import React from 'react'
import { showLayer } from '@/utils/layer'
import $msg from '@/utils/message'
import AddStaff from './staff-list/add-staff/add-staff'
import VersionTip from './components/version-tip/version-tip'
import StaffSeatPurchaseSheet from './components/staff-seat-purchase-sheet/staff-seat-purchase-sheet'
import { getStaffVersionNum, staffTipConfig } from './constants'

interface StaffEntryParams {
    currentVersion: number
    staffNum: number
    maxStaffNum: number
}

export const openStaffEntry = ({ currentVersion, staffNum, maxStaffNum }: StaffEntryParams) => {
    const versionNum = getStaffVersionNum(currentVersion)
    const limitCount = maxStaffNum || versionNum

    if (staffNum < limitCount) {
        return showLayer(<AddStaff />)
    }

    if (currentVersion === 2) {
        $msg('info', `已达员工数量上限(${limitCount}位)`, 4)
        return showLayer(<StaffSeatPurchaseSheet />)
    }

    return showLayer(
        <VersionTip config={staffTipConfig} count={limitCount} canPurchase={currentVersion === 1} canUpgrade />,
    )
}
